import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styles from './AppHeader.module.scss';
import { pathToArray } from 'utils/utils';
import { PATHS } from 'AppClient/routes/AppLayout/AppContent/AppContent';

export const MAIN_NAV_ROUTES = [
	{
		name: 'My bookings',
		path: '/',
		menuKey: '',
	},
];
export interface AppMenuProps {}
export interface AppMenuPropsWithRouter extends RouteComponentProps<{}>, AppMenuProps {}

export interface AppMenuState {
	selected: string;
}
class AppMenu extends Component<AppMenuPropsWithRouter, AppMenuState> {
	constructor(props: AppMenuPropsWithRouter) {
		super(props);

		this.state = {
			selected: this.getMenuItemSelection(),
		};
	}

	getMenuItemSelection() {
		const defaultSelection = PATHS.myBookings;
		const pathname = this.props.location.pathname;

		const pathAsArray = pathToArray(pathname);
		let pathAsId = pathAsArray.length ? pathAsArray[0] : PATHS.myBookings;

		return pathAsId ? pathAsId : defaultSelection;
	}

	componentDidUpdate(prevProps: AppMenuPropsWithRouter) {
		const { location } = this.props;
		if (location.pathname !== prevProps.location.pathname) {
			this.setState({
				selected: this.getMenuItemSelection(),
			});
		}
	}

	render() {
		const { selected } = this.state;
		const currentPage = MAIN_NAV_ROUTES.filter(item => item.menuKey === selected)[0];

		return (
			<div className={styles.appNav}>
				<Helmet>
					<title>{currentPage && currentPage.name}</title>
				</Helmet>
				{MAIN_NAV_ROUTES.map(route => (
					<div
						className={classNames(styles.appNavItem, {
							[styles.active]: selected === route.menuKey,
						})}
						key={route.menuKey}
					>
						<Link to={route.path} className={styles.appNavLink}>
							{route.name}
						</Link>
					</div>
				))}
			</div>
		);
	}
}

export default withRouter<AppMenuPropsWithRouter>(AppMenu);
